/* eslint-disable @typescript-eslint/naming-convention */
export enum Widgets {
  'Background Image' = 'Background Image',
  'Crm' = 'Crm',
  'Featured Games' = 'Featured Games',
  'Feed' = 'Feed',
  'Feedback' = 'Feedback',
  'Game Tickets' = 'Game Tickets',
  'Headline' = 'Headline',
  'News Row' = 'News Row',
  'Recently Played' = 'Recently Played',
  'Stats' = 'Stats',
  'Ticker' = 'Ticker',
  'Twitch' = 'Twitch',
  'Videos' = 'Videos'
}

export enum SingleWidget {
  Feed = 'feed',
  RPG = 'rpg',
  Twitch = 'twitch'
}
